import { ScoutingPlace } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";

const SAVE_ISOCRON = "save_isocron";

@Component
export default class IsocronssMixin extends Vue {
  readonly path = BASE_API_URL + "isocrons";

  updateIsocron(payload: any) {
    return this.$httpPut(`${this.path}/${payload.id}`, SAVE_ISOCRON, payload);
  }
}
